import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Facebook = () => (
    <SingePathIcon path="M16.3998 0.689941H2.25694C1.19182 0.689941 0.328369 1.55339 0.328369 2.61851V16.7614C0.328369 17.8265 1.19182 18.6899 2.25694 18.6899H7.77145V12.5703H5.2402V9.68994H7.77145V7.49458C7.77145 4.99749 9.25806 3.61816 11.535 3.61816C12.6254 3.61816 13.7657 3.81262 13.7657 3.81262V6.26351H12.5093C11.2714 6.26351 10.8853 7.03173 10.8853 7.81963V9.68994H13.6488L13.2068 12.5703H10.8853V18.6899H16.3998C17.4649 18.6899 18.3284 17.8265 18.3284 16.7614V2.61851C18.3284 1.55339 17.4649 0.689941 16.3998 0.689941V0.689941Z" />
);

Facebook.viewBox = `0 0 19 19`;
